import React from 'react';

import { StackableCard } from '../StackableCard';
import { CardStackProps } from './CardStack.types';

export const CardStack = ({ cards = [] }: CardStackProps): JSX.Element => {
  return (
    <>
      {cards.map((card, index) => (
        <StackableCard key={`StackableCard-${index}`} {...card} />
      ))}
    </>
  );
};
